import React from 'react';
import DriveGallery from '../../components/DriveGallery';

const UkonceniPrazdnin = () => (
  <DriveGallery
    galleryId="ukonceni-prazdnin"
    title="Ukončení prázdnin"
  />
);

export default UkonceniPrazdnin;
